import {AutomationFilter} from './reducer/model';
import {RuleFilters, RuleType} from './enums';
import {getAlertFlag} from '../../_shared/GWTBridge/invoke/genPage';
import {formsStore} from '../../stores/Form/FormsStore';

type OptionData = {
    value: string | number | boolean;
    label: string;
};

type MapAppliedFiltersType = {
    [RuleFilters.ruleAction]: OptionData[];
    [RuleFilters.validFor]: OptionData[];
    [RuleFilters.updatedBy]: OptionData[];
    [RuleFilters.isActive]: OptionData[];
};

export const mapAppliedFilters = (appliedFilters: Array<AutomationFilter>) =>
    appliedFilters.reduce((acc, curr) => {
        if (!acc[curr.name]) {
            acc[curr.name] = [];
        }
        acc[curr.name].push(curr.option);
        return acc;
    }, {} as MapAppliedFiltersType);

export const isAlertSuperUser = () => {
    return Boolean(formsStore.sysConstants?.alertflag?.Int) || getAlertFlag();
};

export const multiOptionsHaveValidValue = (data?: number[]) =>
    data && data.filter(val => Boolean(val)).length > 0;

export const supportAIBlock = () => {
    const {host = ''} = window.location;
    const availableHosts = ['priority-connect.online', 'localhost'];
    return availableHosts.some(availableHost => host.includes(availableHost));
};

export const getRuleKeyByValue = (value: RuleType) => {
    return Object.keys(RuleType).find(key => RuleType[key] === value) || '';
};
